import { render, staticRenderFns } from "./Tableau_Bord.vue?vue&type=template&id=10e9ae6d&"
import script from "./Tableau_Bord.vue?vue&type=script&lang=js&"
export * from "./Tableau_Bord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports